var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstituteTutorLogoHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9968 40V15.3651C11.9968 12.6245 11.9968 11.2542 12.486 10.1048C12.9751 8.95547 13.8737 8.21446 15.6708 6.73248L19.8338 3.29936C20.8842 2.43313 21.4094 2 21.9968 2C22.5842 2 23.1094 2.43313 24.1598 3.29936L28.3228 6.73248C30.12 8.21446 31.0184 8.95547 31.5076 10.1048C31.9968 11.2542 31.9968 12.6245 31.9968 15.3651V40",
    stroke: "#A033FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.9082H22.0184",
    stroke: "#A033FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0032 39.9989V25.0215C40.0032 19.1421 37.4848 18.6662 32.0032 16.9082",
    stroke: "#A033FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 39.9989V25.0215C4 19.1421 6.51832 18.6662 12 16.9082",
    stroke: "#A033FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00317 39.998H42.0032",
    stroke: "#A033FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39.9988V29.7363",
    stroke: "#A033FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstituteTutorLogoHover);
export default __webpack_public_path__ + "static/media/Institute Tutor LogoHover.77cf5750e8d8a9d3be19ab7e25df9f3f.svg";
export { ForwardRef as ReactComponent };